import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { DisplayFilterValues } from '../../models/product-filter.models';
import { DisplayFilterIconComponent } from '../display-filter-icon/display-filter-icon.component';

import { Category } from '@core/domain/models/category.models';
import { ProductPublicModels } from '@features/products/product';
import { AttachmentsEnums } from '@shared/header/services/attachments.enums';
import { GridType, GridViewEnum } from '@shared/models/grid-type.model';

@Component({
    selector: 'display-filter',
    templateUrl: './display-filter.component.html',
    standalone: true,
    imports: [
        DisplayFilterIconComponent,
        TranslateModule,
    ],
})
export class DisplayFilterComponent implements OnChanges {
    @Output() public readonly gridTypeEmitter: EventEmitter<GridType> = new EventEmitter();

    @Output() public readonly openFilterPanelEmitter: EventEmitter<null> = new EventEmitter();

    @Input() public gridType: GridType;

    @Input() public readonly category: Category;

    @Input() public readonly totalFiltersCount: boolean;

    public showGridViewSelector: boolean;

    public viewGrid: string;

    public showFilter: boolean;

    public hideStudioView: boolean;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.category?.previousValue !== changes?.category?.currentValue && changes?.category?.currentValue.id) {
            const attachments = changes.category?.currentValue?.attachments || [];

            this.hideStudioView = attachments.some((item) => item.name === AttachmentsEnums.HIDE_STUDIO_VIEW);

            this.getGridViewAndType(attachments);
            this.showFilter = !attachments.some((item) => item.name === 'hide_filters');
            this.showGridViewSelector = !attachments.some((item) => item.name === 'hide_gridview_selector');
        }
    }

    private getGridViewAndType(attachments: ProductPublicModels.PublicApiProductAttachment[]) {
        if (this.hideStudioView) {
            this.viewGrid = GridViewEnum.GRID_2;
            this.gridType = 2;
        } else if (attachments.some((item) => item.name === AttachmentsEnums.FORCE_VIEW_STUDIO)) {
            this.viewGrid = GridViewEnum.GRID_1;
            this.gridType = 1;
        } else if (attachments.some((item) => item.name === AttachmentsEnums.FORCE_VIEW_6)) {
            this.viewGrid = GridViewEnum.GRID_2;
            this.gridType = 2;
        } else if (attachments.some((item) => item.name === AttachmentsEnums.FORCE_VIEW_12)) {
            this.viewGrid = GridViewEnum.GRID_3;
            this.gridType = 3;
        }
    }

    public sendGridView(displayFilter: DisplayFilterValues): void {
        const gridType = displayFilter.value as GridType;
        this.gridTypeEmitter.emit(gridType);
    }

    public openFilterPanel() {
        this.openFilterPanelEmitter.emit();
    }
}
